import { websiteRequest } from 'src/editor/shared/utils/request'
import { WebsitePageResource } from 'src/shared/types/website-page-interface'
import {
  WebsiteStylesInterface,
  WebsiteThemeInterface,
} from 'src/shared/types/website-settings-types'

interface UpdateWebsiteStylesDataInterface extends WebsiteStylesInterface {
  theme?: Omit<WebsiteThemeInterface, 'isCommon'>
}

interface WebsiteStyleResponseInterface extends WebsitePageResource {
  theme: WebsiteThemeInterface
  style: WebsiteStylesInterface
}

export const updateWebsiteStyles = (
  id: number,
  data: UpdateWebsiteStylesDataInterface,
) =>
  websiteRequest<WebsiteStyleResponseInterface>(`websites/${id}/style`, 'PUT', {
    data,
  })
